// extracted by mini-css-extract-plugin
export default {"item":"Tabs_item__6IHn6","icon":"Tabs_icon__IZBXv","item-active":"Tabs_item-active__dFI9C","item-disabled":"Tabs_item-disabled__aC792"};